import { graphql } from '../../../gql';

export const UPDATE_CIRCLE = graphql(`
  mutation updateCircle($input: UpdateCircleInput!) {
    updateCircle(input: $input) {
      ...CircleFields
    }
  }
`);
